
import React, { createContext, ReactNode } from 'react';
import { AuthContextType } from './types';
import { signUp, signIn, signInWithMicrosoft, signOut, resetPassword } from './authService';
import { useAuthEffect } from './useAuthEffect';

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { session, user, loading, setSession, setUser, setLoading } = useAuthEffect();

  const handleSignUp = async (email: string, password: string, metadata?: { first_name?: string; last_name?: string }) => {
    return signUp(email, password, metadata);
  };

  const handleSignIn = async (email: string, password: string) => {
    return signIn(email, password);
  };

  const handleSignInWithMicrosoft = async () => {
    return signInWithMicrosoft();
  };

  const handleSignOut = async () => {
    return signOut();
  };

  const handleResetPassword = async (email: string) => {
    return resetPassword(email);
  };

  return (
    <AuthContext.Provider
      value={{
        session,
        user,
        loading,
        signUp: handleSignUp,
        signIn: handleSignIn,
        signInWithMicrosoft: handleSignInWithMicrosoft,
        signOut: handleSignOut,
        resetPassword: handleResetPassword,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
